import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=98e81546"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98e81546')) {
      api.createRecord('98e81546', component.options)
    } else {
      api.reload('98e81546', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=98e81546", function () {
      api.rerender('98e81546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entity/Form.vue"
export default component.exports